<template>
  <div>
    <div class="mrB10" />
    <sui-grid
      ref="grid"
      :dataset="'dsActivateMgt'"
      :columns="gridColumns0"
      :showDisplayCountControl="false"
      @rowclick="onSelectRow"
    />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        :disabled="nonActiveButtonDisabled"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave('N')"
      >
        {{ $t("MSG_BTN_NON_ACTV") }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        :disabled="activeButtonDisabled"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave('Y')"
      >
        {{ $t("MSG_BTN_ACTV") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T05', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      nonActiveButtonDisabled: true,
      activeButtonDisabled: true,
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ACTV_YN'),
        datafield: 'activeYn',
      }, {
        text: this.$t('MSG_TXT_FST_RGST_DT'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsActivateMgt, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }, {
        text: this.$t('MSG_TXT_FST_RGST_USR'),
        datafield: 'nodeName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageIdRegistration',
              loginId: 'loginIdRegistration',
              knoxId: 'knoxIdRegistration',
              userName: 'userNameRegistration',
              userGlobalName: 'userGlobalNameRegistration',
              departmentName: 'departmentNameRegistration',
              departmentEnglishName: 'departmentEnglishNameRegistration',
            },
          }, this.dsActivateMgt, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_ACTV_END_DT'),
        datafield: 'finalModificationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsActivateMgt, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }, {
        text: this.$t('MSG_TXT_ACTV_END_USR'),
        datafield: 'displayLanguageIdModification',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageIdModification',
              loginId: 'loginIdModification',
              knoxId: 'knoxIdModification',
              userName: 'userNameModification',
              userGlobalName: 'userGlobalNameModification',
              departmentName: 'departmentNameModification',
              departmentEnglishName: 'departmentEnglishNameModification',
            },
          }, this.dsActivateMgt, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_DETAIL'),
        datafield: 'detailButton',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickView,
            type: 'positive',
          }, this.dsActivateMgt, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  watch: {
    ruleUid() {
      if (!utils.isEmpty(this.ruleUid)) {
        this.setWorkflowActivateMgt();
      }
    },
  },
  mounted() {
    this.dsActivateMgt.$on(this.dsActivateMgt.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
    if (!utils.isEmpty(this.ruleUid)) {
      this.setWorkflowActivateMgt();
    }
  },
  destroyed() {
    this.dsActivateMgt.$off(this.dsActivateMgt.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  methods: {
    onClickView(value, row) {
      utils.openTextAreaEditor(null, {
        title: this.$t('MSG_TIT_RUL_LOG_SRCH'),
        pageInitialData: {
          value: row.rulePracticeLogicContent,
          readonly: true,
          positiveButtonText: this.$t('MSG_BTN_CFRM'),
        },
      });
    },
    /**
     * 저장
     */
    onClickSave(value) {
      const selectedData = this.dsActivateMgt.getSelectedRawData();
      if (utils.size(selectedData) < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return;
      }
      const dataParams = {
        rulePracticeLogicUid: selectedData[0].rulePracticeLogicUid,
        workflowId: selectedData[0].workflowId,
        activeYn: value,
      };

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00052', {
          data: dataParams,
        }).then(res => {
          if (utils.isEqual(res.data.resultCode, '0')) {
            utils.messageBox('warning', '', res.data.msg.split('\n'));
          } else {
            utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
              this.$emit('onClickSearch');
              this.setWorkflowActivateMgt();
            });
          }
        });
      });
    },
    /**
     * row 선택
     */
    onSelectRow(event) {
      const { rowindex } = event.args;
      this.dsActivateMgt.setSelectedIndex(rowindex);
    },
    /**
     * 조회
     */
    setWorkflowActivateMgt() {
      http.request(this.pageId, 'DTS_CMR_00051', {
        query: {
          ruleUid: this.ruleUid,
        },
      }).then(res => {
        utils.forEach(res.data, (obj, index) => {
          // 활성화여부가 Y인 경우 종료일자,사용자 표시 x
          if (utils.isEqual(res.data[index].activeYn, 'Y')) {
            res.data[index].finalModificationDTM = '';
            res.data[index].displayLanguageIdModification = '';
            res.data[index].knoxIdModification = '';
            res.data[index].loginIdModification = '';
            res.data[index].userNameModification = '';
            res.data[index].userGlobalNameModification = '';
            res.data[index].departmentNameModification = '';
            res.data[index].departmentEnglishNameModification = '';
          }
          // 상세 버튼명 설정
          res.data[index].detailButton = this.$t('MSG_BTN_VIEW');
        });
        this.dsActivateMgt.submit();
        this.dsActivateMgt.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /* row 선택에 따른 button disabled 처리 */
    datasetSelectionChanged(value) {
      const { activeYn } = this.dsActivateMgt.data[value.newSelections];

      this.nonActiveButtonDisabled = utils.isEqual(activeYn, 'N');
      this.activeButtonDisabled = utils.isEqual(activeYn, 'Y');
    },
  },

  datasets: [{
    id: 'dsActivateMgt',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'rulePracticeLogicUid', map: 'rulePracticeLogicUid' },
      { type: 'string', name: 'rulePracticeLogicContent', map: 'rulePracticeLogicContent' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'ruleUid', map: 'ruleUid' },
      { type: 'string', name: 'activeYn', map: 'activeYn' },
      { type: 'string', name: 'loginIdModification', map: 'loginIdModification' },
      { type: 'string', name: 'loginIdRegistration', map: 'loginIdRegistration' },
      { type: 'string', name: 'knoxIdModification', map: 'knoxIdModification' },
      { type: 'string', name: 'knoxIdRegistration', map: 'knoxIdRegistration' },
      { type: 'string', name: 'userNameModification', map: 'userNameModification' },
      { type: 'string', name: 'userNameRegistration', map: 'userNameRegistration' },
      { type: 'string', name: 'userGlobalNameModification', map: 'userGlobalNameModification' },
      { type: 'string', name: 'userGlobalNameRegistration', map: 'userGlobalNameRegistration' },
      { type: 'string', name: 'departmentNameModification', map: 'departmentNameModification' },
      { type: 'string', name: 'departmentNameRegistration', map: 'departmentNameRegistration' },
      { type: 'string', name: 'departmentEnglishNameModification', map: 'departmentEnglishNameModification' },
      { type: 'string', name: 'departmentEnglishNameRegistration', map: 'departmentEnglishNameRegistration' },
      { type: 'string', name: 'displayLanguageIdModification', map: 'displayLanguageIdModification' },
      { type: 'string', name: 'displayLanguageIdRegistration', map: 'displayLanguageIdRegistration' },
      { type: 'string', name: 'detailButton', map: 'detailButton' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
    ],
  }],
};
</script>
<style scoped>
</style>
